// Where a visit's "not ready" link opens (D202, H7 §3). Each link opens the open
// item for THAT visit's patient, or is hidden when there is no open item: a link
// to a list root would hand the person a queue and make them find it.
import { getItemsSync } from '@/features/human-in-the-loop/store';
import { getSentSync, getToSendSync } from '@/features/preauths/store';
import type { Visit } from './readinessMock';

export function visitLink(visit: Visit): { label: string; to: string } | null {
  const link = visit.notReady?.link;
  if (!link) return null;
  const who = visit.patient.toLowerCase();

  if (link.to === '/human-in-the-loop') {
    const task = getItemsSync().find((t) => `${t.title} ${t.metaLine}`.toLowerCase().includes(who));
    return task ? { label: link.label, to: `/human-in-the-loop/${task.id}` } : null;
  }

  if (link.to === '/pre-auths') {
    const toSend = getToSendSync().find((p) => p.patient.toLowerCase() === who);
    if (toSend) return { label: link.label, to: `/pre-auths/${toSend.id}` };
    const sent = getSentSync().find((p) => p.patient.toLowerCase() === who);
    return sent ? { label: link.label, to: `/pre-auths/${sent.id}` } : null;
  }

  return link;
}
